import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '../Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DialogueBase from './DialogueBase';
import { useLocation, useHistory } from 'react-router-dom';
import * as track from '../../lib/track';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'center',
      width: '100%',
      padding: '1rem 0',
    },
  },
  button: {
    marginRight: '1rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '1rem',
    },
  },
  img: {
    width: '14rem',
    display: 'block',
    margin: '0 2.5rem',
  },
  icon: {
    color: theme.palette.common.tealish,
  },
}));

const SignUpCTA = ({open, onClose}) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  const clickClose = () => {
    track.sendEvent('cta close button', 'click');
    onClose();
  };

  const clickLogin = () => {
    track.sendEvent('cta login button', 'click');
    history.push({pathname: '/login', state:{redirectTo:location.pathname}});
  };

  const clickSignup = () => {
    track.sendEvent('cta signup button', 'click');
    history.push('/signup');
  };

  return (
    <DialogueBase
      open={open}
      title="Sign up to Clickability and have your voice heard!"
      aria-labelledby="sign-up-cta"
    >
      <div className={classes.content}>
        <List>
          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon className={classes.icon} fontSize="large"/>
            </ListItemIcon>
            <Typography variant="body2">
              Write reviews for providers and services.
            </Typography>
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon className={classes.icon} fontSize="large"/>
            </ListItemIcon>
            <Typography variant="body2">
              Easily find and engage accredited providers.
            </Typography>
          </ListItem>

          <ListItem>
            <ListItemIcon>
              <CheckCircleIcon className={classes.icon} fontSize="large"/>
            </ListItemIcon>
            <Typography variant="body2">
              Maximise the value of your NDIS plan!
            </Typography>
          </ListItem>

        </List>
      </div>
      <div className={classes.buttons}>
        <Button
          variant="outlined"
          label="Not right now"
          cssStyle="large"
          pointer="none"
          aria-label="Back to page"
          onClick={clickClose}
          className={classes.button}
        />
        <Button
          variant="outlined"
          label="I already have an account"
          cssStyle="large"
          aria-label="Login"
          onClick={clickLogin}
          className={classes.button}
        />
        <Button
          variant="contained"
          label="I&apos;m ready to sign up"
          cssStyle="large"
          aria-label="Sign up"
          onClick={clickSignup}
          className={classes.button}
        />
      </div>

    </DialogueBase>
  );
};

SignUpCTA.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SignUpCTA;
